import styled from "styled-components";

export const ThisButton = styled.div`
  cursor: pointer;
`;